import { mat4 } from "gl-matrix";
import { AnimationFrame } from "@spi/Common/Animation";
import { RenderObject } from "../Object/RenderObject";

export class AnimationState {

    public renderObject: RenderObject;
    public currentState: string;
    private animationStart: Date;

    public allowedStates: StateDefinition = {
        'Idle': {
            repeat: 'always',
            speed: 0.5
        },
        'Walk': {
            repeat: 'always',
            speed: 1.0
        },
        'Death': {
            repeat: 'once',
            speed: 0.3
        },
        'Attack': {
            repeat: 'once',
            nextState: 'Idle',
            speed: 0.4
        }
    };

    constructor(object: RenderObject) {
        this.renderObject = object;
        this.animationStart = new Date();
    }

    public switchState(newState: string) {
        let state = this.allowedStates[newState];
        if (state && newState !== this.currentState) {
            this.currentState = newState;
            this.animationStart = new Date();
        }
    }

    public getFrames(): FrameSet {

        let state = this.allowedStates[this.currentState];

        let result: FrameSet = {
            frames: [],
            frameIndex: 0,
            state: this.currentState
        };

        let resultFrames: AnimationFrame[] = [];

        let last = true;

        let now = new Date().getTime();
        let startTime = this.animationStart.getTime();

        for (let joint of this.renderObject.animation.joints) {
            let frames = joint.animationFrames[this.currentState];

            let f: number;
            for (f = 0; f < frames.length; f++) {
                let frame = frames[f];

                if (startTime + (frame.timeStep * state.speed * 1000) > now) {

                    break;
                }
            }

            last = last && f === frames.length;
            if (f === frames.length) {
                result.frameIndex = f - 1;
                result.frames.push(frames[f - 1]);
            } else {
                result.frameIndex = f;
                result.frames.push(frames[f]);
            }
        }

        if (last) {
            switch (state.repeat) {
                case 'always':
                    this.animationStart = new Date();
                    break;
                case 'once':
                    if (state.nextState) {
                        this.switchState(state.nextState);
                    }
                    break;
            }
        }

        return result;
    }
}

type StateDefinition = {
    [key: string]: {
        repeat: string,
        speed: number,
        nextState?: string
    }
}

type FrameSet = {
    frames: AnimationFrame[],
    state: string,
    frameIndex: number
}